import { render, staticRenderFns } from "./invDataUp.vue?vue&type=template&id=421a5ebe"
import script from "./invDataUp.vue?vue&type=script&lang=js"
export * from "./invDataUp.vue?vue&type=script&lang=js"
import style0 from "./invDataUp.vue?vue&type=style&index=0&id=421a5ebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports